// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')

class EnvironmentRecord extends Immutable.Record({
  articlePlaceholder: String(),
  baseUrl: String(),
  bookmarkletHref: String(),
  browser: Immutable.Map(),
  buildNumber: String(),
  csrfToken: String(),
  deeplinkUrls: Immutable.Map(),
  nativeEmbedded: Boolean(),
  openInAppDismissed: Boolean(),
  userPlaceholder: String()
}) {
  // No methods
}

EnvironmentRecord.reviver = keyedReviver(EnvironmentRecord, {
  browser: defaultReviver,
  deeplinkUrls: defaultReviver
})

EnvironmentRecord.propTypes = {
  articlePlaceholder: PropTypes.string,
  baseUrl: PropTypes.string,
  bookmarkletHref: PropTypes.string,
  browser: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string
  ])),
  buildNumber: PropTypes.string,
  csrfToken: PropTypes.string,
  deeplinkUrls: PropTypes.objectOf(PropTypes.string),
  nativeEmbedded: PropTypes.bool,
  openInAppDismissed: PropTypes.bool,
  userPlaceholder: PropTypes.string
}

module.exports = EnvironmentRecord
